/* Smalsutis: мягкое появление кастомных секций при скролле.
   Дополняет встроенный reveal Dawn (scroll-trigger), который
   не покрывает custom-liquid блоки. Без библиотек. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '#MainContent .hiw, #MainContent .sm-helps, #MainContent .sm-topbar, #MainContent div[style*="background:#E1DAC0"]'
  );
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sm-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    // элементы уже в зоне видимости при загрузке не прячем — без мигания
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) return;
    el.classList.add('sm-reveal');
    observer.observe(el);
  });
})();
